<div class="d-flex flex-row sb-star-rating">
    @switch (kind) {
        @case (StarRatingViewKind.CardStars) {
            <div class="d-flex flex-row">
                @for (rating of starLevels; track rating) {
                    <ng-container *ngTemplateOutlet="starCardIcon; context: { $implicit: rating }"></ng-container>
                }
            </div>
        }
        @case (StarRatingViewKind.Summary) {
            <div class="sb-star-rating-average-rate">
                {{ starRating | formatDecimal: 0 : 1 }}
                <lib-icon
                    class="sb-star-selected"
                    [icon]="Icon.Common.Star"
                    [size]="IconSize.Medium"></lib-icon>
            </div>
        }
        @case (StarRatingViewKind.Reviews) {
            <lib-button
                class="star-rating-link"
                [kind]="ButtonKind.Link"
                [size]="ButtonSize.Small"
                [disabled]="disabled"
                (clicked)="SummaryClicked()">
                <ng-container label>
                    <div class="sb-star-rating-average">
                        <div class="sb-star-rating-average-rate">
                            {{ starRating | formatDecimal: 0 : 1 }}
                            <lib-icon
                                class="sb-star-selected"
                                [icon]="Icon.Common.Star"
                                [size]="IconSize.Medium"></lib-icon>
                        </div>
                        @if (numReviews == 1) {
                            <ng-container i18n="@@CommonOneReviewCountBrackets">
                                (1 review)
                            </ng-container>
                        } @else if (numReviews && numReviews > 1) {
                            <ng-container i18n="@@CommonXStarRatingCountReviewsBrackets">
                                ({{ numReviews }} reviews)
                            </ng-container>
                        }
                    </div>
                </ng-container>
            </lib-button>
        }
        <!-- UXDEBT: Not tokenized yet -->
        @case (StarRatingViewKind.Website) {
            <div class="d-flex gap-space-6 align-items-baseline">
                <div class="d-flex gap-space-2 align-items-baseline">
                    <p
                        class="typography-headline-large"
                        [ngClass]="websiteTextClass">
                        {{ starRating | formatDecimal: 0 : 1 }}
                    </p>
                    <lib-icon
                        class="align-self-end margin-bottom-4"
                        [ngClass]="websiteTextClass"
                        [icon]="Icon.Common.Star"
                        [size]="IconSize.Medium"></lib-icon>
                </div>
                @if (numReviews == 1) {
                    <p
                        class="typography-title-small"
                        [ngClass]="websiteTextClass"
                        i18n="@@CommonOneReviewCountBrackets">
                        (1 review)
                    </p>
                } @else if (numReviews && numReviews > 1) {
                    <p
                        class="typography-title-small"
                        [ngClass]="websiteTextClass"
                        i18n="@@CommonXStarRatingCountReviewsBrackets">
                        ({{ numReviews }} reviews)
                    </p>
                }
            </div>
        }
    }
</div>

<ng-template
    #starCardIcon
    let-rating>
    @if (starRating != null && rating <= starRating) {
        <lib-icon
            class="sb-star-readOnly"
            [icon]="Icon.Common.Star"
            [size]="IconSize.Medium"></lib-icon>
    } @else {
        <lib-icon
            class="sb-star-default"
            [icon]="Icon.Common.StarOutline"
            [size]="IconSize.Medium"></lib-icon>
    }
</ng-template>
